




import {Component, Prop, Vue} from 'vue-property-decorator'
import DataGrid, {DataType} from '@/components/DataGrid.vue'
import {reformatDate} from "@/data/sources/dates"
import {executeQuery} from "@/data/repos/query"

@Component({
  components: {
    DataGrid,
  },
})
export default class JobsRaisedFinancialYearDrillDown extends Vue {
  @Prop() public args!: { from: string, to: string, status: number, hdPPMRepairAll: number }
  public fields = [
    {name: 'Reported_Date_Time', title: 'Reported', dataType: DataType.Date, sort: 1},
    {name: 'Reporter_Name', title: 'Reporter name', dataType: DataType.Text, sort: 1},
    {name: 'Problem_Short_Desc', title: 'Short description', dataType: DataType.Text, sort: 1},
    {name: 'Site_Desc', title: 'Site', dataType: DataType.Text, sort: 1},
    {name: 'Building_Desc', title: 'Building', dataType: DataType.Text, sort: 1},
    {name: 'Status', title: 'Status', dataType: DataType.Text, sort: 1},
    {name: 'Complete_Date', title: 'Completed', dataType: DataType.Date, sort: 1},
  ]
  // private fromDate: string = "2018-04-01";
  // private toDate: string = "2019-03-31";

  public getData(offset: number = 0, limit: number = 250) {
    function filter(data: any[]): any[] {
      return data.map((v) => {
          return {
            ...v,
            Reported_Date_Time: reformatDate(v.Reported_Date_Time),
            Complete_Date: reformatDate(v.Complete_Date),
          }
        },
      )
    }

    return executeQuery(
      "FMS_DB",
      "jobsRaisedFinancialYear_Grid",
      {from: this.args.from, to: this.args.to, ppmRepair: this.args.hdPPMRepairAll, status: this.args.status},
      filter,
      offset, limit)
  }
}
